import { useState, useCallback } from 'react'
import { Card, Chip, Grid } from '@enterprise-ui/canvas-ui-react'
import { FilterPopup } from '../globalComponents/FilterPopup'
import {
  APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS,
  COST_SEARCH_VIEW_BY_OPTIONS,
  COST_SEARCH_VIEW_BY_OPTIONS_DVS,
  COST_SEARCH_TIMEFRAME_OPTIONS,
} from '../globalConfig/constants'

export const AppliedFilter = ({ selectedValues, removeValue }) => {
  const ALL_COST_SEARCH_VIEW_BY_OPTIONS = {
    ...COST_SEARCH_VIEW_BY_OPTIONS,
    ...COST_SEARCH_VIEW_BY_OPTIONS_DVS,
  }
  const [openPopup, setOpenPopup] = useState(false)
  const [popupFieldConstant, setPopupFieldConstant] = useState()
  const [popupValues, setPopupValues] = useState([])

  const onFilterPopupOpen = (fieldConstant, fieldValues) => {
    setPopupFieldConstant(fieldConstant)
    setPopupValues(fieldValues)
    setOpenPopup(true)
  }

  const onFilterPopupClose = useCallback(() => {
    setOpenPopup(false)
  }, [])

  const showAllItemsChip = () => {
    return Object.values(APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS).every(
      (field) =>
        selectedValues[field.variableName]?.length === 0 ||
        (field.filterType === 'CHECKBOX' &&
          selectedValues[field.variableName] === false),
    )
  }

  return (
    <>
      <Card className="hc-pa-normal hesp-card-border hesp-card-background">
        <div className="hc-fs-lg">
          Applied Search Criteria
          {showAllItemsChip() ? (
            <>
              <Grid.Item className="hc-pa-none hesp-general-fullwidth">
                <Chip
                  data-testid="all_items_chip"
                  className="hesp-chip-plain hesp-appliedfilters-chip"
                >
                  Active Items
                </Chip>
              </Grid.Item>
            </>
          ) : (
            <>
              {Object.keys(APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS).map(
                (key, index) => {
                  if (
                    APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS[key].filterType ===
                      'CHECKBOX' &&
                    selectedValues[
                      APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS[key].variableName
                    ] === true
                  ) {
                    return (
                      <>
                        <Grid.Item className="hc-pa-none hesp-general-fullwidth">
                          <Chip
                            data-testid="historical_items_chip"
                            className="hesp-chip-plain hesp-appliedfilters-chip"
                          >
                            Include Historical Items
                          </Chip>
                        </Grid.Item>
                      </>
                    )
                  } else if (
                    ['TEXT', 'AUTOCOMPLETE'].includes(
                      APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS[key].filterType,
                    ) &&
                    selectedValues[
                      APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS[key].variableName
                    ].length !== 0
                  ) {
                    return (
                      <Grid.Item
                        className="hc-pa-none hesp-general-fullwidth"
                        key={key + '_griditem'}
                      >
                        <div className="hesp-position-relative">
                          {selectedValues[
                            APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS[key]
                              .variableName
                          ].length === 1 ? (
                            <Chip
                              data-testid={
                                APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS[key]
                                  .variableName + '_single_chip'
                              }
                              className="hesp-chip-plain hesp-appliedfilters-chip"
                              onRequestDelete={(event) => {
                                event.stopPropagation()
                                removeValue(
                                  [],
                                  APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS[key]
                                    .variableName,
                                  [],
                                  true,
                                )
                              }}
                              key={key + index + '_chip'}
                            >
                              {
                                APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS[key]
                                  .label
                              }
                              {' = '}
                              {selectedValues[
                                APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS[key]
                                  .variableName
                              ].toString()}
                            </Chip>
                          ) : (
                            <Chip
                              data-testid={
                                APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS[key]
                                  .variableName + '_multi_chip'
                              }
                              className="hesp-chip-plain hesp-appliedfilters-chip"
                              onClick={() =>
                                onFilterPopupOpen(
                                  APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS[key],
                                  selectedValues[
                                    APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS[key]
                                      .variableName
                                  ],
                                )
                              }
                              onRequestDelete={(event) => {
                                event.stopPropagation()
                                removeValue(
                                  [],
                                  APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS[key]
                                    .variableName,
                                  [],
                                  true,
                                )
                              }}
                              key={key + index + '_chip'}
                            >
                              {
                                selectedValues[
                                  APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS[key]
                                    .variableName
                                ].length
                              }{' '}
                              {
                                APPLIED_FILTERS_SEARCH_CRITERIA_FIELDS[key]
                                  .pluralLabel
                              }
                            </Chip>
                          )}
                        </div>
                      </Grid.Item>
                    )
                  }
                  return null
                },
              )}
            </>
          )}
        </div>
        <div className="hc-fs-lg">
          View By
          {selectedValues.costLocationGroup.costLocationGroupValues.length !==
          0 ? (
            <Grid.Item className="hc-pa-none hesp-general-fullwidth">
              <div className="hesp-position-relative">
                {selectedValues.costLocationGroup.costLocationGroupValues
                  .length === 1 ? (
                  <Chip
                    data-testid="costlocation_chip"
                    className="hesp-chip-plain hesp-appliedfilters-chip"
                    onClick={() =>
                      onFilterPopupOpen(
                        ALL_COST_SEARCH_VIEW_BY_OPTIONS[
                          selectedValues.costLocationGroup.costLocationGroupType
                        ],
                        selectedValues.costLocationGroup
                          .costLocationGroupValues,
                      )
                    }
                    onRequestDelete={(event) => {
                      event.stopPropagation()
                      removeValue(
                        [],
                        ALL_COST_SEARCH_VIEW_BY_OPTIONS[
                          selectedValues.costLocationGroup.costLocationGroupType
                        ]?.variableName,
                        [],
                        true,
                      )
                    }}
                  >
                    {
                      ALL_COST_SEARCH_VIEW_BY_OPTIONS[
                        selectedValues.costLocationGroup.costLocationGroupType
                      ]?.label
                    }
                    {' = '}
                    {selectedValues.costLocationGroup.costLocationGroupValues}
                  </Chip>
                ) : (
                  <Chip
                    data-testid="costlocation_chip"
                    className="hesp-chip-plain hesp-appliedfilters-chip"
                    onClick={() =>
                      onFilterPopupOpen(
                        ALL_COST_SEARCH_VIEW_BY_OPTIONS[
                          selectedValues.costLocationGroup.costLocationGroupType
                        ],
                        selectedValues.costLocationGroup
                          .costLocationGroupValues,
                      )
                    }
                    onRequestDelete={(event) => {
                      event.stopPropagation()
                      removeValue(
                        [],
                        ALL_COST_SEARCH_VIEW_BY_OPTIONS[
                          selectedValues.costLocationGroup.costLocationGroupType
                        ]?.variableName,
                        [],
                        true,
                      )
                    }}
                  >
                    {
                      selectedValues.costLocationGroup.costLocationGroupValues
                        .length
                    }{' '}
                    {
                      ALL_COST_SEARCH_VIEW_BY_OPTIONS[
                        selectedValues.costLocationGroup.costLocationGroupType
                      ]?.pluralLabel
                    }
                  </Chip>
                )}
              </div>
            </Grid.Item>
          ) : [
              ALL_COST_SEARCH_VIEW_BY_OPTIONS.CHAIN?.variableName,
              ALL_COST_SEARCH_VIEW_BY_OPTIONS.SUPPLIER_CHAIN?.variableName,
            ].includes(
              selectedValues.costLocationGroup.costLocationGroupType,
            ) ? (
            <>
              <Grid.Item className="hc-pa-none hesp-general-fullwidth">
                <Chip
                  data-testid="costlocation_chip"
                  className="hesp-chip-plain hesp-appliedfilters-chip"
                >
                  All Locations
                </Chip>
              </Grid.Item>
            </>
          ) : (
            <>
              <Grid.Item className="hc-pa-none hesp-general-fullwidth">
                <Chip
                  data-testid="costlocation_chip"
                  className="hesp-chip-plain hesp-appliedfilters-chip"
                >
                  {
                    ALL_COST_SEARCH_VIEW_BY_OPTIONS[
                      selectedValues.costLocationGroup.costLocationGroupType
                    ]?.label
                  }
                </Chip>
              </Grid.Item>
            </>
          )}
        </div>
        <div className="hc-fs-lg">
          Timeframe
          <Grid.Item className="hc-pa-none hesp-general-fullwidth">
            <div className="hesp-position-relative">
              {selectedValues.timeframe === 'CURRENT' ? (
                <Chip
                  data-testid="timeframe_chip"
                  className="hesp-chip-plain hesp-appliedfilters-chip"
                >
                  Current Cost
                </Chip>
              ) : (
                <Chip
                  data-testid="timeframe_chip"
                  className="hesp-chip-plain hesp-appliedfilters-chip"
                >
                  Future Cost ={' '}
                  {
                    selectedValues?.[
                      COST_SEARCH_TIMEFRAME_OPTIONS.START_DATE.variableName
                    ]
                  }
                </Chip>
              )}
            </div>
          </Grid.Item>
        </div>
        <FilterPopup
          data-testid="filters_popup"
          fieldConstant={popupFieldConstant}
          isVisible={openPopup}
          values={popupValues}
          onRefuse={onFilterPopupClose}
          onRemove={removeValue}
          removeChip={true}
        />
      </Card>
    </>
  )
}
